import React ,{ReactNode,FC}from 'react'

interface CardTitleProps {
    textColor:string;
    children: ReactNode
}



export const CardTitle:FC<CardTitleProps> = ({textColor,children}) => {
  return (
      <h4 className='m-0 fw-semibold' style={{color:textColor,fontSize:'15px'}}>{children}</h4>
  )
}


